import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { BRANCHES } from '@constants/routes';

const AddNewBranch = lazy(
  () => import('@features/branch-management/pages/add-new-branch/AddNewBranch')
);

const SettlementModeSelection = lazy(
  () =>
    import(
      '@features/branch-management/pages/add-new-branch/SettlementModeSelection'
    )
);

export const BranchRoutes: RouteObject[] = [
  {
    path: BRANCHES.ADD_NEW_BRANCH,
    element: <AddNewBranch />
  },
  {
    path: BRANCHES.EDIT_BRANCH,
    element: <AddNewBranch />
  },
  {
    path: BRANCHES.MANAGE_BANK_ACCOUNT,
    element: <SettlementModeSelection />
  }
];

export default BranchRoutes;
